import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Register from './views/Register.vue'
import SignIn from './views/SignIn.vue'
import BasicRouterView from './views/BasicRouterView.vue'

import Profile from './views/settings/Profile.vue'
import Settings from './views/settings/Settings.vue'
import MachineTokens from './views/settings/MachineTokens.vue'

import ManagementHome from './views/management/ManagementHome.vue'
import UserList from './views/management/UserList.vue'
import UserDetails from './views/management/UserDetails.vue'
import UserDetailsProfile from './views/management/userdetails/Profile.vue'
import UserDetailsSocialLogin from './views/management/userdetails/SocialLogin.vue'
import UserDetailsContact from './views/management/userdetails/Contact.vue'
import UserDetailsLogs from './views/management/userdetails/Logs.vue'
import UserDetailsSecurity from './views/management/userdetails/Security.vue'
import UserDetailsDevices from './views/management/userdetails/Devices.vue'
import UserDetailsMetadata from './views/management/userdetails/Metadata.vue'
import UserCreate from './views/management/UserCreate.vue'
import RoleList from './views/management/RoleList.vue'
import RoleDetails from './views/management/RoleDetails.vue'
import EmailTemplateSettings from './views/management/EmailTemplateSettings.vue'
import SMSTemplateSettings from './views/management/SMSTemplateSettings.vue'

import Unauthorized from './views/error/Unauthorized.vue'

import LogList from './views/management/LogList.vue'

import i18n from './i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // Match Boostrap-Vue active case for link
  linkExactActiveClass: 'active',
  base: '/web/',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    props: true
  }, {
    path: '/register',
    name: 'Register',
    component: Register,
    props: true
  }, {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
    props: true
  }, {
    path: '/management',
    component: BasicRouterView,
    children: [{
      path: '',
      name: 'ManagementHome',
      component: ManagementHome
    }, {
      path: 'users',
      name: 'UserList',
      component: UserList,
      meta: {
        title: i18n.t('user_list.meta.title')
      },
      props (route) {
        return {
          isShowCreateUserAlert: route.params.isShowCreateUserAlert,
          pageToken: route.query.pageToken,
          sort: route.query.sort,
          ascending: route.query.ascending,
          qsQueryKey: route.query.queryKey,
          qsQueryValue: route.query.queryValue
        }
      }
    }, {
      path: 'users/:id(\\d+)',
      component: BasicRouterView,
      props (route) {
        return {
          id: parseInt(route.params.id, 10)
        }
      },
      children: [{
        path: '/',
        name: 'UserDetails',
        component: UserDetails,
        meta: {
          title: i18n.t('user_details.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'profile',
        name: 'UserDetailsProfile',
        component: UserDetailsProfile,
        meta: {
          title: i18n.t('user_details_profile.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'social_login',
        name: 'UserDetailsSocialLogin',
        component: UserDetailsSocialLogin,
        meta: {
          title: i18n.t('user_details_social_login.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'contact/:type',
        name: 'UserDetailsContact',
        component: UserDetailsContact,
        meta: {
          title: i18n.t('user_details_contact.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10),
            type: route.params.type
          }
        }
      }, {
        path: 'logs',
        name: 'UserDetailsLogs',
        component: UserDetailsLogs,
        meta: {
          title: i18n.t('user_details_logs.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'security',
        name: 'UserDetailsSecurity',
        component: UserDetailsSecurity,
        meta: {
          title: i18n.t('user_details_security.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'devices',
        name: 'UserDetailsDevices',
        component: UserDetailsDevices,
        meta: {
          title: i18n.t('user_details_devices.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }, {
        path: 'metadata',
        name: 'UserDetailsMetadata',
        component: UserDetailsMetadata,
        meta: {
          title: i18n.t('user_details_metadata.meta.title')
        },
        props (route) {
          return {
            id: parseInt(route.params.id, 10)
          }
        }
      }]
    }, {
      path: 'users/new',
      name: 'UserCreate',
      component: UserCreate,
      meta: {
        title: i18n.t('user_create.meta.title')
      }
    }, {
      path: 'logs',
      name: 'LogList',
      component: LogList,
      meta: {
        title: i18n.t('log_list.meta.title')
      },
      props (route) {
        return {
          pageToken: route.query.pageToken
        }
      }
    }, {
      path: 'roles',
      name: 'RoleList',
      component: RoleList,
      meta: {
        title: i18n.t('role_list.meta.title')
      },
      props (route) {
        return {
          pageToken: route.query.pageToken
        }
      }
    }, {
      path: 'roles/:id',
      name: 'RoleDetails',
      component: RoleDetails,
      meta: {
        title: i18n.t('role_details.meta.title')
      },
      props: function (route) {
        return {
          id: parseInt(route.params.id, 10)
        }
      }
    }, {
      path: 'settings/email/template',
      name: 'EmailTemplateSettings',
      component: EmailTemplateSettings,
      meta: {
        title: i18n.t('email_template_settings.meta.title')
      }
    }, {
      path: 'settings/sms/template',
      name: 'SMSTemplateSettings',
      component: SMSTemplateSettings,
      meta: {
        title: i18n.t('sms_template_settings.meta.title')
      }
    }]
  }, {
    path: '/settings',
    component: BasicRouterView,
    children: [{
      path: '',
      component: Home
    }, {
      path: 'profile',
      name: 'Profile',
      component: Profile,
      meta: {
        title: i18n.t('profile.meta.title')
      }
    }, {
      path: 'settings',
      name: 'Settings',
      component: Settings,
      meta: {
        title: i18n.t('settings.meta.title')
      }
    }, {
      path: 'tokens',
      name: 'MachineTokens',
      component: MachineTokens
    }]
  }, {
    path: '/401',
    name: 'Unauthorized',
    component: Unauthorized
  }]
})

export default router
